/**
 * 范围框整个X轴
 * Y轴 - 数值
 * 浮窗 - 数值
 * 最大值 - 100
 */
export default function getEchartsOptionLineD3(
	xAxis_data, 
	series_data, 
	expansion_data, 
	markArea_range, 
	isDifferentColors,
	colorArr
) {

	if (!colorArr || colorArr.length == 0) {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	let pieces = [];
	if (colorArr && colorArr.length > 0) {
		let front = false;
		let frontIndex = 0;
		for (let i = 0; i < colorArr.length; i++) {
			let item = colorArr[i];
			if (i == 0) {
				front = item;
				frontIndex = i;
			} else {
				if (front != item) {
					let needColor;
					if (isDifferentColors) {
						if (front == 1) {
							needColor = 'rgba(253, 175, 187, 1)'
						} else {
							needColor = 'rgba(154, 181, 241, 1)'
						}
					} else {
						needColor = 'rgba(154, 181, 241, 1)';
					}
					let piecesItem = {
						gt: frontIndex - 1,
						lte: i - 1,
						color: needColor,
						symbolSize: 7.5,
					}
					pieces.push(piecesItem);
					front = item;
					frontIndex = i;
				}
			}
		}
		let needColor;
		if (isDifferentColors) {
			if (colorArr[colorArr.length - 1] == 1) {
				needColor = 'rgba(253, 175, 187, 1)'
			} else {
				needColor = 'rgba(154, 181, 241, 1)'
			}
		} else {
			needColor = 'rgba(154, 181, 241, 1)';
		}
		let piecesItem = {
			gt: frontIndex - 1,
			lte: colorArr.length - 1,
			color: needColor,
			symbolSize: isDifferentColors ? 7.5 : 7.5,
		}
		pieces.push(piecesItem);
	}


	let markArea_data = (markArea_range && markArea_range.length == 2) ? [
		[
			{ yAxis: markArea_range[0] },
			{ yAxis: markArea_range[1] },
		]
	] : undefined;

	let markLine_data = (markArea_range && markArea_range.length == 2) ? [
		{
			yAxis: markArea_range[0]
		},
		{
			yAxis: markArea_range[1]
		}
	] : undefined



	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#D8E2F8",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {
				// 获取日期
				let date = expansion_data[val[0].dataIndex] || '';

				// 获取数值
				let value = val[0].value;

				// 区分颜色
				let dotColor = 'rgba(74, 124, 232, 1)';
				let textColor = 'rgba(131, 148, 185, 1)';
				if (isDifferentColors) {
					if (colorArr[val[0].dataIndex] == 1) {
						dotColor = 'rgba(255, 113, 134, 1)';
						textColor = 'rgba(255, 113, 134, 1)';
					}
				}

				// 弹窗样式
				let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${date}</div>`
				let contentDiv = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${value}</div>
				</div>
				`
				return titleDiv + contentDiv;
			}
		},
		xAxis: {
			type: 'category',
			data: xAxis_data,
			axisTick: {
				show: false,
			},
			axisLabel: {
				textStyle: {
					color: "#A5A9BC", //坐标的字体颜色
					fontSize: 10
				}
			},
			axisLine: {
				lineStyle: {
					color: "rgba(144, 148, 166, 0.1)",
					type: "solid",
				},
			},
		},
		yAxis: {
			type: 'value',
			axisLine: {
				show: false,
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				textStyle: {
					color: "#A5A9BC",
					fontSize: 10
				},
			},
			splitNumber: 2,
			max: 100
		},
		visualMap: {
			show: false,
			dimension: 0,
			pieces: pieces
		},
		series: [
			{
				data: series_data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 6,
				markArea: {
					itemStyle: {
						color: 'rgba(74, 124, 232, 0.05)',
						lineStyle: {
							type: "dashed",
							color: "#8287F4",
						},
						// borderColor: "#4A7CE8",
						// borderWidth: 1,
						// borderType: 'dashed',
					},
					data: markArea_data,
				},
				markLine: {
						zIndex: -1,
						symbol: ['none', 'none'],
						label: {
						show: false
						},
						lineStyle: {
							color: '#9EB8F1'
						},
						emphasis: {
							disabled: true // 关闭高亮
						},
						data: markLine_data
				},
				emphasis: {
					scale: 1.5
				}
			}
		]
	};
	return option;
}